import { createSlice } from '@reduxjs/toolkit'
import { mapSocketFactory } from '../../../utils/socketFactory'

const initialState = {
  showPermissionDialog: false,

}


const mediaPlaybackSlice = createSlice({
  name: 'mediaPlayback',
  initialState,
  reducers: {
    setshowPermissionDialog: (state, action) => {
      state.showPermissionDialog = action.payload
    }

  }
})

export const {
  setshowPermissionDialog,
} = mediaPlaybackSlice.actions



export default mediaPlaybackSlice.reducer